import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../ChartTableToggle";
import GnaMetricsVolumeAnylysis from "./GnaMetricsVolume";
import GnaMetricsCostAnylysis from "./GnaMetricsCost";
import GnaTgnaStatisticsAnylysis from "./GnaStatisticMetrics";
// import DailyAnalysis from "./DailyUtilisation/DailyAnalysis";
// import MonthAnalysis from "./DailyUtilisation/MonthAnalysis";
import { fetchOptimizerMetrics } from "../../../Utility/RestApi";
const DataTabs = ["Volume", "Cost"];

export default function GnaTgnaMetricsAnylysis({
  selectedBlock,
  refreshKey,
  setError,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    // if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const res = await fetchOptimizerMetrics();
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="load-data flex flex-wrap items-center w-full h-full md:overflow-hidden rounded-2xl border border-[#718EBF1C] !shadow-[rgba(149,157,165,0.2)_0px_8px_24px] !p-2">
        <div className=" !bg-[#fff]  w-full !min-h-[100%] overflow-auto">
          <div className="flex justify-between items-center mb-3">
            <h2 className="chartHeading w-60">Key Indicators Snapshot</h2>
            <div className="flex items-center gap-3">
              <ToggleTabs
                tabs={DataTabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </div>
          {/* {activeTab === "Volume" && ( */}
          <GnaMetricsVolumeAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading}
            data={data}
          />
          {/* )} */}
          {/* {activeTab === "Cost" && (
            <GnaMetricsCostAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={loading}
              data={data}
            />
          )} */}
          <GnaTgnaStatisticsAnylysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            activeTab={activeTab}
          />
        </div>
      </div>
    </>
  );
}
